(function(){
  'use strict';

  var SHAVING_URL='/collections/shaving-cabinets';
  var SHAVING_IMAGE='https://cdn.shopify.com/s/files/1/0853/4009/4779/collections/eyJidWNrZXQiOiJ3ZWItbmluamEtaW1hZ2VzIiwia2V5Ijoib3R0aW5ldy9pbWFnZXMvcHJvZGltZy8xMzI4OF8xLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MTIwMCwiaGVpZ2h0IjoxMjAwLCJmaXQiOiJpbnNpZGUiLCJ3aXR.jpg?v=1785600414';

  function text(element){
    return String(element&&element.textContent||'').replace(/\s+/g,' ').trim().toLowerCase();
  }

  function removeNestedShavingLink(container){
    if(!container) return;
    container.querySelectorAll('a').forEach(function(link){
      if(link.getAttribute('href')===SHAVING_URL||text(link)==='shaving cabinets') link.remove();
    });
  }

  function addDesktopCategory(header){
    var grid=header.querySelector('.nv-product-grid');
    if(!grid) return;

    var vanityCard=null;
    grid.querySelectorAll('.nv-product-card').forEach(function(card){
      var name=card.querySelector('.nv-tile-name');
      if(text(name)==='vanities') vanityCard=card;
    });
    if(!vanityCard) return;

    removeNestedShavingLink(vanityCard.querySelector('.nv-card-menu'));
    if(grid.querySelector('.nv-shaving-category-card')) return;

    var card=document.createElement('div');
    card.className='nv-product-card nv-shaving-category-card';

    var link=document.createElement('a');
    link.className='nv-tile';
    link.href=SHAVING_URL;

    var thumb=document.createElement('span');
    thumb.className='nv-tile-thumb nv-tile-thumb--circle';

    var image=document.createElement('img');
    image.src=SHAVING_IMAGE;
    image.alt='Shaving Cabinets';
    image.loading='lazy';
    image.width=180;
    image.height=180;

    var name=document.createElement('span');
    name.className='nv-tile-name';
    name.textContent='Shaving Cabinets';

    thumb.appendChild(image);
    link.appendChild(thumb);
    link.appendChild(name);
    card.appendChild(link);
    vanityCard.insertAdjacentElement('afterend',card);
  }

  function addMobileCategory(header){
    var productGroup=header.querySelector('.nv-mobile-group .nv-mobile-group__content');
    if(!productGroup) return;

    var vanityCategory=null;
    productGroup.querySelectorAll('.nv-mobile-category').forEach(function(category){
      var summary=category.querySelector(':scope > summary');
      if(text(summary)==='vanities') vanityCategory=category;
    });
    if(!vanityCategory) return;

    removeNestedShavingLink(vanityCategory);
    if(productGroup.querySelector('.nv-shaving-mobile-category')) return;

    var link=document.createElement('a');
    link.className='nv-mobile-direct nv-shaving-mobile-category';
    link.href=SHAVING_URL;
    link.textContent='Shaving Cabinets';
    vanityCategory.insertAdjacentElement('afterend',link);
  }

  function configure(scope){
    (scope||document).querySelectorAll('[data-nuvio-header]').forEach(function(header){
      addDesktopCategory(header);
      addMobileCategory(header);
    });
  }

  function boot(){ configure(document); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',function(event){ configure(event.target); });
})();
